<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.amzFtyNoticeInNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          size="mini"
          :type="
            formData.amzFtyNoticeInStatus == 'Y'
              ? 'success'
              : formData.amzFtyNoticeInStatus == 'F'
              ? 'info'
              : formData.amzFtyNoticeInStatus == 'S'
              ? 'warning'
              : formData.amzFtyNoticeInStatus == 'D'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_amzFtyNoticeInStatus || 'New' }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="baseForm"
      size="mini"
      :model="formData"
      :rules="formRules"
      :disabled="disabled"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_bookContractNo') || '外运单号'"
            prop="bookContractNo"
          >
            <el-input
              v-model.trim="formData.bookContractNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_cust') || '下单客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_endCust') || '终端客户'"
            prop="endCustCode"
          >
            <dict-select
              v-model="formData.endCustCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_buyer') || '跟单业务'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.buyerName"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_ecomWarehouse') || '入库仓库'"
            prop="ecomWarehouseCode"
          >
            <dict-select
              v-model="formData.ecomWarehouseCode"
              url="/ecom/warehouse/cn/warehouse/select"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              @change="warehouseChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_whContactName') || '仓库联系人'"
            prop="whContactName"
          >
            <el-input
              v-model.trim="formData.whContactName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_whContactMobile') || '仓库联系人手机'"
            prop="whContactMobile"
          >
            <el-input
              v-model.trim="formData.whContactMobile"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_whContactEmail') || '仓库联系人邮箱'"
            prop="whContactEmail"
          >
            <el-input
              v-model.trim="formData.whContactEmail"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_scm') || '供应商'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.scmName"
              size="mini"
              filterable
              clearable
              @change="scmChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_scmContactName') || '供应商联系人'"
            prop="scmContactName"
          >
            <el-input
              v-model.trim="formData.scmContactName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_scmContactMobile') || '供应商联系人手机'"
            prop="scmContactMobile"
          >
            <el-input
              v-model.trim="formData.scmContactMobile"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_scmContactEmail') || '供应商联系人邮箱'"
            prop="scmContactEmail"
          >
            <el-input
              v-model.trim="formData.scmContactEmail"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_deliveryDate') || '预约日期'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              style="width: 100%;"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_whReceivingTimeDesc') || '仓库收货时间'"
            prop="whReceivingTimeDesc"
          >
            <el-input
              v-model="formData.whReceivingTimeDesc"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="1000"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          {{ $l('form_group_title') || '送货确认信息' }}
        </span>
        <el-divider
          direction="vertical"
          v-if="optType == 'send' || optType == 'confirm'"
        ></el-divider>
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-primary"
          v-if="optType == 'send'"
          @click="sendWarehouse"
        >
          {{ $l('btn_sendWarehouse') || '通知送仓' }}
        </b-button>
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-primary"
          v-if="optType == 'confirm'"
          @click="confirmCarrier"
        >
          {{ $l('btn_confirmCarrier') || '提交送货确认信息' }}
        </b-button>
      </div>
    </div>
    <el-form
      ref="carrierForm"
      size="mini"
      :model="formData"
      :rules="formRules"
      :disabled="optType != 'confirm' && optType != 'adjust'"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_comfirmDeliveryDate') || '确认送达日期'"
            prop="comfirmDeliveryDate"
          >
            <el-date-picker
              v-model="formData.comfirmDeliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              style="width: 100%;"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_carrierName') || '运输车牌号（快递公司）'"
            prop="carrierName"
          >
            <el-input
              v-model="formData.carrierName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="200"
              clearable
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="
              $l('form_label_carrierInfo') || '司机姓名及电话（快递单号）'
            "
            prop="carrierInfo"
          >
            <el-input
              v-model="formData.carrierInfo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="200"
              clearable
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SkuTable
      ref="skuTable"
      class="mt-1"
      :scmCode="formData.scmCode"
      :amzFtyNoticeInCode="amzFtyNoticeInCode"
      :amzFtyNoticeOutCode="amzFtyNoticeOutCode"
      :disabled="disabled"
      :disabledPrint="disabledPrint"
    />

    <ChooseScmContacts
      :visible.sync="chooseScmContactsVisible"
      :title="
        `${formData.scmName}-${$l('dialog_title_chooseScmContacts') ||
          '联系人'}`
      "
      :scmCode="formData.scmCode"
      @confirm="scmContactsConfirm"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import { request } from '@/api/service'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from '../sku-table'
import ChooseScmContacts from '@/views/ecom/components/choose-scm-contacts'
export default {
  mixins: [EditLoading],
  components: { SkuTable, ChooseScmContacts },
  props: {
    amzFtyNoticeInCode: { type: String, default: '' },
    optType: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    disabledPrint: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        scmCode: '',
        scmContactName: '',
        scmContactMobile: '',
        scmContactEmail: '',
        whContactName: '',
        whContactMobile: '',
        whContactEmail: '',
        whReceivingTimeDesc: '',
        buyerName: '',
        amzFtyNoticeInStatus: '',
      },
      chooseScmContactsVisible: false,
      amzFtyNoticeOutCode: '',
    }
  },
  computed: {
    formRules() {
      return {
        bookContractNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        ecomWarehouseCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        whContactName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        whContactMobile: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        whContactEmail: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        scmContactName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        scmContactMobile: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        scmContactEmail: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        deliveryDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        whReceivingTimeDesc: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        comfirmDeliveryDate: [
          {
            required: this.carrierFormRequired,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        carrierName: [
          {
            required: this.carrierFormRequired,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        carrierInfo: [
          {
            required: this.carrierFormRequired,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      }
    },
    carrierFormRequired() {
      const { amzFtyNoticeInStatus } = this.formData
      return (
        this.optType == 'confirm' ||
        (this.optType == 'adjust' && amzFtyNoticeInStatus == 'F')
      )
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.amzFtyInboundCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.buyerCode = userCode || ''
        this.formData.buyerName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    reload() {
      this.getData()
      this.$refs.skuTable.getData()
    },
    async getData() {
      if (this.optType != 'add' && this.amzFtyNoticeInCode) {
        const res = await this.$api
          .ecomAmzFtyNoticeInDetailApi({
            amzFtyNoticeInCode: this.amzFtyNoticeInCode,
          })
          .catch(() => null)
        if (!res) return
        this.formData = res.body || {}
      }
      if (this.optType == 'add' && this.amzFtyNoticeInCode) {
        this.amzFtyNoticeOutCode = this.amzFtyNoticeInCode
        const res = await this.$api
          .ecomAmzFtyNoticeOutDetailApi({
            amzFtyNoticeOutCode: this.amzFtyNoticeOutCode,
          })
          .catch(() => null)
        if (!res) return
        const {
          bookContractNo,
          custCode,
          endCustCode,
          buyerCode,
          buyerName,
          ecomWarehouseCode,
          scmCode,
          scmName,
          deliveryDate,
          whReceivingTimeDesc,
          amzFtyNoticeOutCode,
        } = res.body || {}
        this.formData = {
          ...this.formData,
          bookContractNo,
          custCode,
          endCustCode,
          buyerCode,
          buyerName,
          ecomWarehouseCode,
          scmCode,
          scmName,
          deliveryDate,
          whReceivingTimeDesc,
          amzFtyNoticeOutCode,
        }
        this.warehouseChange(ecomWarehouseCode)
        this.scmInfoChange(scmCode, false)
      }
    },
    async warehouseChange(code) {
      if (!code) return
      const res = await request({
        url: '/ecom/warehouse/detail',
        method: 'POST',
        data: { ecomWarehouseCode: code },
      }).catch(() => null)
      if (!res) return

      const {
        whContactName,
        whContactMobile,
        whContactEmail,
        remark,
      } = res.body
      this.formData.whContactName = whContactName
      this.formData.whContactMobile = whContactMobile
      this.formData.whContactEmail = whContactEmail
      this.formData.whReceivingTimeDesc = remark
    },
    scmChange(code) {
      this.scmInfoChange(code, true)
    },
    async scmInfoChange(code, flag) {
      if (!code) return
      const res = await request({
        url: '/digitalCenter/scmInfoContacts/list',
        method: 'POST',
        data: { scmCode: code },
      }).catch(() => null)
      if (!res) return

      const { data } = res.body
      if (!data || !data.length) return
      if (data.length > 1 && flag) return (this.chooseScmContactsVisible = true)

      const { contactName, contactMobile, contactEmail } = data[0]
      this.formData.scmContactName = contactName
      this.formData.scmContactMobile = contactMobile
      this.formData.scmContactEmail = contactEmail
    },
    scmContactsConfirm(data) {
      if (!data?.length) return
      const contactName = [
        ...new Set(data.map((item) => item.contactName).filter(Boolean)),
      ].join()
      const contactMobile = [
        ...new Set(data.map((item) => item.contactMobile).filter(Boolean)),
      ].join()
      const contactEmail = [
        ...new Set(data.map((item) => item.contactEmail).filter(Boolean)),
      ].join()
      this.formData.scmContactName = contactName
      this.formData.scmContactMobile = contactMobile
      this.formData.scmContactEmail = contactEmail
    },
    saveApi(params) {
      return this.optType == 'adjust'
        ? this.$api.ecomAmzFtyNoticeInAdjustApi(params).catch(() => null)
        : this.$api.ecomAmzFtyNoticeInSaveApi(params).catch(() => null)
    },
    async save() {
      if (!(await this.validate())) return

      const details = await this.$refs.skuTable.getTableData()
      const params = { ...this.formData, details }

      this.loadingOpen()
      const res = await this.saveApi(params)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.optType != 'add' && this.amzFtyNoticeInCode) {
        this.reload()
        return
      }

      const { amzFtyNoticeInCode = '', amzFtyNoticeInNo = '' } = body || {}
      if (amzFtyNoticeInCode) {
        this.$router.replace({
          name: 'ecom-awsBiz-ftyInvInNotice-detail',
          params: { amzFtyNoticeInCode, pageType: 'edit' },
          query: { amzFtyNoticeInNo },
        })
        return
      }
    },
    async validate() {
      const baseForm = await validate.formValidate([this.$refs.baseForm])
      const carrierForm = await validate.formValidate([this.$refs.carrierForm])
      const skuResult = await this.$refs.skuTable.validate()
      return baseForm && carrierForm && skuResult
    },
    async sendWarehouse() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_sendWarehouse') || '是否要进行通知送仓操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const res = await this.$api
        .ecomAmzFtyNoticeInSendWarehouseApi({
          amzFtyNoticeInCodeList: [this.amzFtyNoticeInCode],
        })
        .catch(() => null)
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('通知失败！')
        return
      }
      this.$message({ showClose: true, message: '通知成功！', type: 'success' })

      const { amzFtyNoticeInCode, amzFtyNoticeInNo } = this.formData
      // await this.closeCurPage()
      this.$router.replace({
        name: 'ecom-awsBiz-ftyInvInNotice-detail',
        params: { amzFtyNoticeInCode, pageType: 'detail' },
        query: { amzFtyNoticeInNo },
      })
    },
    async confirmCarrier() {
      const result = await validate.formValidate([this.$refs.carrierForm])
      if (!result) return

      const confirm = await this.$confirm(
        this.$l('tips_confirm_confirmCarrier') || '是否要提交送货确认信息？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const { comfirmDeliveryDate, carrierName, carrierInfo } = this.formData

      const res = await this.$api
        .ecomAmzFtyNoticeInConfirmCarrierApi({
          amzFtyNoticeInCode: this.amzFtyNoticeInCode,
          comfirmDeliveryDate,
          carrierName,
          carrierInfo,
        })
        .catch(() => null)
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('提交失败！')
        return
      }
      this.$message({ showClose: true, message: '提交成功！', type: 'success' })
      const { amzFtyNoticeInCode, amzFtyNoticeInNo } = this.formData
      // await this.closeCurPage()
      this.$router.replace({
        name: 'ecom-awsBiz-ftyInvInNotice-detail',
        params: { amzFtyNoticeInCode, pageType: 'detail' },
        query: { amzFtyNoticeInNo },
      })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.span-style {
  font-size: 30px;
  line-height: 22px;
  color: #888888;
}
</style>
